export default class OrderStateHistoryType {
  static get Create () { return 'create' } // Создание заказа
  static get Status () { return 'status' }
  static get Menu () { return 'menu' } // Изменение блюд
  static get Filial () { return 'filial' } // Изменение филиала
  static get Promocode () { return 'promocode' } // Изменение промокода
  static get PaymentType () { return 'payment_type' } // Изменение типа оплаты
  static get DeliveryType () { return 'delivery_type' } // Адрес и тип доставки
  static get Preorder () { return 'preorder' } // время предзаказа
  static get AssemblyComment () { return 'assembly_comment' } // коментарий для сборки
  static get CourierComment () { return 'courier_comment' } // коментарий для курьера
  static get Complete () { return 'complete' } // заказ завершен
  static get Cancel () { return 'cancel' } // заказ отменен
  static get Call () { return 'call' } // звонок
  static get PaymentCancel () { return 'payment_cancel' } // платеж отменен
  static get OrderPaid () { return 'order_paid' } // платеж отменен
}
